import { Component, Inject } from '@angular/core';
import { SimpleTextDialogData } from './models/simple-text-dialog-data.model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-simple-text-dialog',
    templateUrl: './simple-text-dialog.component.html',
    styleUrls: ['./simple-text-dialog.component.scss'],
    standalone: false
})
export class SimpleTextDialogComponent {

  constructor(private readonly dialogRef: MatDialogRef<SimpleTextDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: SimpleTextDialogData) { }

  closeWithConfirm(): void {
    this.dialogRef.close(true);
  }

  close() : void {
    this.dialogRef.close(false);
  }
}
